import get from 'lodash/get.js';

import BaseInterceptor from '@/router/interceptors/BaseInterceptor.js';

class AccessDeniedInterceptor extends BaseInterceptor {
    handle(status, error) {
        const routeMatch = ['/login'].includes(this.$router.currentRoute.value.path);

        if ((status === 403 || status === 412) && !routeMatch) {
            if (this.$router.currentRoute.value.name !== '403' && get(error.config, 'errorHandle') !== false) {
                this.$router.push({
                    name: '403',
                    params: {
                        message: get(error, 'response.data.message'),
                        exception: get(error, 'response.data.exception'),
                        meta: get(error, 'response.meta'),
                    },
                });
            }
        }
    }
}

export default AccessDeniedInterceptor;
